import { useState } from "react";
import "./PreviousMatchReponseBlock.css";
import axios from "axios";
import { getVip } from "../../handlers/dictionaryHandler.js";

const PreviousMatchResponseBlock = ({
  otherName,
  weeklyMatchesUsageLeft,
  matchId,
  otherId,
  onMatchRenewal,
  isOtherActive,
}) => {
  const [answerText, setAnswerText] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const isAlreadySaidYes = true;

  const alertUser = (message) => {
    setAlertMessage(message);
    setShowAlert(true);
  };

  const renewMatch = async () => {
    if (isOtherActive === false) {
      alertUser("המשתמש בהשהיית שימוש");
      return;
    }

    if (localStorage.getItem("VIP") !== "1") {
      alertUser("אופס... רק מנויים יכולים למחזר התאמות");
      return;
    }

    if (answerText.length === 0) {
      alertUser("רק צריך להשאיר כמה מילים לצד השני ואפשר לנסות שוב 😊");
      return;
    }

    setIsSubmitting(true);
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      };
      await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + `/prevMatches_proc`,
        {
          matchId,
          otherId,
          msgForOtherSide: answerText,
        },
        config,
      );
      await onMatchRenewal(matchId);
      const message = `שלחנו הודעה ל ${otherName} 😊בהצלחה`;
      setAlertMessage(message);
      setShowAlert(true);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        alertUser("כבר חידשת את ההתאמה הזו השבוע 😊");
      } else {
        alertUser("לא הצלחנו למחזר את ההתאמה, נסה שוב או מאוחר יותר");
      }
      console.log("Could not renew match", error);
    }
    setIsSubmitting(false);
  };

  return (
    <div className="response-container">
      <div className="faceline">
        <div>
          <div id="btnSubmit" style={{ fontSize: 16 }}>
            היית רוצה לנסות שוב?
          </div>
          <div id="btnSubmit" style={{ fontSize: 16 }}>
            יש לך אפשרות למחזר עוד {weeklyMatchesUsageLeft} התאמות קודמות 😊
            אפשר להשאיר הודעה ולשמור, והמערכת תקפיץ את ההתאמה לצד השני
          </div>
          <div>
            <div className={"freetext-container"}>
              <textarea
                style={{ height: "40px" }} // Fix: 'style' instead of 'Style'
                className="freetext"
                rows="3"
                maxLength="100"
                value={answerText}
                onChange={(e) => setAnswerText(e.target.value)}
              ></textarea>
            </div>
          </div>

          <div
            id="btnSubmit"
            value="אשמח להכיר :)"
            onClick={async () => {
              if (!isSubmitting) {
                await renewMatch();
              }
            }}
            style={{
              backgroundColor:
                answerText.length > 0
                  ? "var(--btn-color)"
                  : "var(--grey-color)",
              margin: "14px auto 0",
              padding: 4,
              borderWidth: 0,
              textAlign: "center",
              fontSize: 20,
              borderRadius: 10,

              fontFamily: "Heebo-VariableFon",
              color: "var(--btnText-color)",
              cursor: isSubmitting ? "default" : "pointer",
              // visually keep as before
              opacity: 1,
              pointerEvents: isSubmitting ? "none" : "auto", // Prevents click if submitting
              userSelect: isSubmitting ? "none" : "auto", // Prevents accidental selection
            }}
          >
            {isAlreadySaidYes ? "אשמח להכיר :)" : "כן, אשמח לנסות שוב התאמה זו"}
          </div>
          {showAlert && (
            <div className="error-message">
              <h5>{alertMessage} </h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviousMatchResponseBlock;
